/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css, keyframes } from '@emotion/react';
import { ArchiveSideBarWidth } from './styles';
import { DN500 } from '@atlaskit/theme/colors';
import { TouchScrollable } from 'react-scrolllock';
var archiveItemViewerWrapperStyles = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'center'
});
var archiveSideBarStyles = css({
  padding: "22px ".concat("var(--ds-space-250, 20px)", " ", "var(--ds-space-250, 20px)", " ", "var(--ds-space-250, 20px)"),
  backgroundColor: "var(--ds-surface, #101214)",
  position: 'absolute',
  left: 0,
  top: 0,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  width: "".concat(ArchiveSideBarWidth, "px"),
  bottom: 0,
  boxSizing: 'border-box',
  overflowY: 'scroll'
});
var slideDown = keyframes({
  '0%': {
    opacity: 0,
    transform: 'translateY(-100%)'
  },
  '100%': {
    transform: 'translateY(0)',
    opacity: 1
  }
});
var archiveDownloadButtonWrapperStyles = css({
  padding: "var(--ds-space-100, 8px)".concat(" 7px 5px ", "var(--ds-space-100, 8px)"),
  border: 'none',
  borderRadius: '3px',
  backgroundColor: 'transparent',
  color: "var(--ds-icon, #9FADBC)",
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #A1BDD914)"
  },
  '&:active': {
    cursor: 'pointer',
    backgroundColor: "var(--ds-background-neutral-subtle-pressed, #A6C5E229)"
  }
});
var disabledArchiveDownloadButtonWrapperStyles = css({
  padding: "var(--ds-space-100, 8px)".concat(" 7px 5px ", "var(--ds-space-100, 8px)"),
  border: 'none',
  borderRadius: '3px',
  backgroundColor: 'transparent',
  color: "var(--ds-icon, #9FADBC)",
  cursor: 'not-allowed'
});
var archiveSidebarFolderWrapperStyles = css({
  transform: 'translateY(-100%)',
  transition: 'all 1s',
  opacity: 0,
  animation: "".concat(slideDown, " 0.3s forwards")
});
var sidebarItemWrapperStyles = css({
  width: '85%'
});
var archiveSidebarFileEntryWrapperStyles = css({
  paddingBottom: "var(--ds-space-075, 5px)",
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.3s'
});
var archiveLayoutStyles = css({
  display: 'flex',
  width: '100%',
  height: '100%'
});
var archiveViewerWrapperStyles = css({
  position: 'absolute',
  top: 0,
  // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  left: "".concat(ArchiveSideBarWidth, "px"),
  right: 0,
  bottom: 0,
  alignItems: 'center',
  display: 'flex'
});
var separatorStyles = css({
  borderRadius: '1px',
  height: '2px',
  margin: "var(--ds-space-200, 19px)".concat(" 0"),
  backgroundColor: "var(--ds-border, #A6C5E229)",
  flexShrink: 0
});
var sidebarHeaderWrapperStyles = css({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0
});
var sidebarHeaderIconStyles = css({
  display: 'flex',
  alignItems: 'center',
  marginRight: "var(--ds-space-100, 10px)",
  flexShrink: 0
});
var sidebarHeaderEntryStyles = css({
  flex: '1 1 auto',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 1.14286,
  color: "var(--ds-text, ".concat(DN500, ")")
});
export var ArchiveItemViewerWrapper = function ArchiveItemViewerWrapper(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: archiveItemViewerWrapperStyles
  }, children);
};
export var ArchiveSideBar = function ArchiveSideBar(_ref2) {
  var children = _ref2.children;
  return jsx(TouchScrollable, null, jsx("div", {
    css: archiveSideBarStyles
  }, children));
};
export var ArchiveSidebarFolderWrapper = function ArchiveSidebarFolderWrapper(_ref3) {
  var children = _ref3.children;
  return jsx("div", {
    css: archiveSidebarFolderWrapperStyles,
    "data-testid": "archive-sidebar-folder-wrapper"
  }, children);
};
export var ArchiveDownloadButtonWrapper = function ArchiveDownloadButtonWrapper(_ref4) {
  var children = _ref4.children,
    onClick = _ref4.onClick;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("div", {
      css: archiveDownloadButtonWrapperStyles,
      onClick: onClick,
      "data-testid": "media-archiveDownloadButton"
    }, children)
  );
};
export var DisabledArchiveDownloadButtonWrapper = function DisabledArchiveDownloadButtonWrapper(_ref5) {
  var children = _ref5.children;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsx("div", {
      css: disabledArchiveDownloadButtonWrapperStyles,
      "data-testid": "media-disabledArchiveDownloadButton"
    }, children)
  );
};
export var SidebarItemWrapper = function SidebarItemWrapper(_ref6) {
  var children = _ref6.children;
  return jsx("div", {
    css: sidebarItemWrapperStyles
  }, children);
};
export var ArchiveSidebarFileEntryWrapper = function ArchiveSidebarFileEntryWrapper(_ref7) {
  var children = _ref7.children,
    index = _ref7.index;
  return jsx("div", {
    css: archiveSidebarFileEntryWrapperStyles,
    key: index
  }, children);
};
export var ArchiveLayout = function ArchiveLayout(_ref8) {
  var children = _ref8.children;
  return jsx("div", {
    css: archiveLayoutStyles,
    "data-testid": "archive-layout"
  }, children);
};
export var ArchiveViewerWrapper = function ArchiveViewerWrapper(_ref9) {
  var children = _ref9.children;
  return jsx("div", {
    css: archiveViewerWrapperStyles
  }, children);
};
export var Separator = function Separator() {
  return jsx("div", {
    css: separatorStyles
  });
};
export var SidebarHeaderWrapper = function SidebarHeaderWrapper(_ref10) {
  var children = _ref10.children;
  return jsx("span", {
    css: sidebarHeaderWrapperStyles
  }, children);
};
export var SidebarHeaderIcon = function SidebarHeaderIcon(_ref11) {
  var children = _ref11.children;
  return jsx("div", {
    css: sidebarHeaderIconStyles
  }, children);
};
export var SidebarHeaderEntry = function SidebarHeaderEntry(_ref12) {
  var children = _ref12.children;
  return jsx("div", {
    css: sidebarHeaderEntryStyles
  }, children);
};